import { cur } from '../lib/units';
import { flowSaved, f1 } from '../lib/leakCalc';

const Num = ({ testid, label, value, onChange }) => <label>{label}<input inputMode="decimal" data-testid={testid} value={value ?? ''} onChange={(e) => onChange(e.target.value.replace(',', '.'))} /></label>;

// before/after repair flow -> verified water savings
export default function FlowCheck({ t, obj, patch }) {
  const fc = { unit: 'ls', ...(obj.flowCheck || {}) }, r = flowSaved(fc);
  const set = (k) => (v) => patch({ flowCheck: { ...fc, [k]: v } });
  const u = fc.unit === 'm3h' ? 'm³/h' : 'l/s';
  return (
    <div className="fx-box flow-check" data-testid="flow-check">
      <b>📊 {t.fcTitle}</b>
      <div className="sw-grid">
        <Num testid="flow-before-input" label={`${t.fcBefore} (${u})`} value={fc.before} onChange={set('before')} />
        <Num testid="flow-after-input" label={`${t.fcAfter} (${u})`} value={fc.after} onChange={set('after')} />
        <label>&nbsp;<select data-testid="flow-unit-select" value={fc.unit} onChange={(e) => set('unit')(e.target.value)}><option value="ls">l/s</option><option value="m3h">m³/h</option></select></label>
      </div>
      {r && (
        <p className={`pr-alert ${r.ls > 0 ? 'lk-ok' : 'low'}`} data-testid="flow-saved">
          {r.ls > 0 ? `✅ ${t.fcSaved}: ` : `⚠️ ${t.fcNone}: `}<b>{f1(r.ls, 2)} l/s</b> ({f1(r.pct, 0)} %) · {f1(r.m3d)} m³/d · <b>{f1(r.m3a, 0)} m³/a</b> · <b>{f1(r.eur, 0)} {cur()}/a</b>
        </p>
      )}
    </div>
  );
}
